import sa from 'superagent';

class BaseAPI {
  constructor(baseUrl, token) {
    this.baseUrl = baseUrl;
    this.token = token;
  }

  _exec(req) {
    return req.set('Authorization', `Bearer ${this.token}`)
      .set('Content-Type', 'application/json')
      .then(data => data);
  }

  get(url) {
    return this._exec(sa.get(`${this.baseUrl}${url}`));
  }

  post(url, payload) {
    return this._exec(sa.post(`${this.baseUrl}${url}`).send(payload));
  }

  put(url, payload) {
    return this._exec(sa.put(`${this.baseUrl}${url}`).send(payload));
  }

  del(url) {
    return this._exec(sa.del(`${this.baseUrl}${url}`));
  }
}

export default BaseAPI;
